import React from 'react';
import { Modal, SystemText } from '@salesperformanceint/e4shared';
import { withRouter } from 'react-router-dom';

import { StaffReviewsModal } from '../staffReviewsModal';
import { ObjectivesModal } from '../objectivesModal';
import { StaffObjectivesModal } from '../staffObjectivesModal';
import { FeedbackObjectivesModal } from '../feedbackObjectivesModal';
import { SharedObjectivesModal } from '../sharedObjectivesModal';
import { YourBlogsModal } from '../yourBlogsModal';
import { AnswersModal } from '../answersModal';
import { useDispatch, useSelector } from 'react-redux';
import { setHomeWhatsHappening } from 'actions/dashboard';
import UnreviewedModal from '../unreviewedModal';
import PathwayModal from '../pathwayModal';

export const WhatsHappeningModal = ({ history }) => {
    const dispatch = useDispatch();

    const { show, data } = useSelector(state => state.dashboard.homeWhatsHappening);

    const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/Details/${path}`, ...rest);

    const setShow = () => dispatch(setHomeWhatsHappening({}));

    const modalTitle = () => {
        switch (show) {
            case 'staff-reviews':
                return st('Title/StaffReviews');
            case 'objectives':
                return st('Title/Objectives');
            case 'objectivesAI':
                return st('Title/ObjectivesAI');
            case 'staff-objectives':
                return st('Title/StaffObjectives');
            case 'feedback-objectives':
                return st('Title/FeedbackObjectives');
            case 'shared-objectives':
                return st('Title/SharedObjectives');
            case 'your-blogs':
                return st('Title/BlogPosts');
            case 'answers':
                return st('Title/Answers');
            case 'pathways':
                return st('Title/Pathways');
            default:
                return 'Summary';
        }
    };

    const modalFooter = (
        <div>
            {show === 'unreviewed' && (
                <button
                    data-testid="button-unreviewed"
                    className="btn btn-success"
                    onClick={() => history.push('/review-tracker?unreviewed=1')}
                >
                    <i className="fa fa-users mr10" />
                    {st('Unreviewed/Button')}
                </button>
            )}
            <button data-testid="button-close" className="btn" onClick={() => setShow()}>
                {st('Close')}
            </button>
        </div>
    );

    return (
        <Modal show={show} title={modalTitle()} close={() => setShow()} footer={modalFooter}>
            {show === 'staff-reviews' && <StaffReviewsModal data={data.staffReviews} st={st} />}
            {show === 'objectives' && <ObjectivesModal data={data.objectives} st={st} />}
            {show === 'objectivesAI' && <ObjectivesModal data={data.objectivesAI} st={st} />}
            {show === 'staff-objectives' && <StaffObjectivesModal data={data.staffObjectives} st={st} />}
            {show === 'feedback-objectives' && <FeedbackObjectivesModal data={data.feedbackObjectives} st={st} />}
            {show === 'shared-objectives' && <SharedObjectivesModal data={data.sharedObjectives} st={st} />}
            {show === 'your-blogs' && <YourBlogsModal data={data.yourBlogs} st={st} />}
            {show === 'answers' && <AnswersModal data={data.answers} st={st} />}
            {show === 'unreviewed' && <UnreviewedModal data={data.unreviewed} st={st} />}
            {show === 'pathways' && <PathwayModal data={data.pathways} st={st} />}
        </Modal>
    );
};

export default withRouter(WhatsHappeningModal);
